import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LOCALE_ID, NgModule } from '@angular/core';
// import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import '@angular/common/locales/global/tr';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { environment } from '../environments/environment';

import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';

import { AuthModule } from './auth/auth.module';

import { TopbarComponent } from './topbar/topbar.component';

import { DashboardComponent } from './dashboard/dashboard.component';
import { ItemsListComponent } from './items/items-list/items-list.component';
// import { PosComponent } from './pos/pos/pos.component';
import { TestComponent } from './test/test.component';

import { CurrencyConverterComponent } from './shared/currency-converter/currency-converter.component';

import { StatusComponent } from './status/status.component';
// import { CartModule } from './cart/cart.module';
import { PopModule } from './pop/pop.module';
import { ReportsModule } from './reports/reports.module';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
// import { reducers, metaReducers } from './reducers';
import { EffectsModule } from '@ngrx/effects';
import { RouterState, StoreRouterConnectingModule } from '@ngrx/router-store';

// import { PosModule } from './pos/pos.module';

@NgModule({
  declarations: [
    AppComponent,
    TopbarComponent,
    DashboardComponent,
    // CodeSearchComponent,
    ItemsListComponent,
    // PosComponent,
    TestComponent,
    CurrencyConverterComponent,
    
    StatusComponent
  ],
  exports: [
    ItemsListComponent
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    // FontAwesomeModule,
    AngularFireModule.initializeApp(environment.firebase),
    AuthModule,
    AppRoutingModule,
    AngularFirestoreModule.enablePersistence(),
    HttpClientModule,
    // CartModule,
    PopModule,
    // PosModule
    ReportsModule,
    // StoreModule.forRoot(reducers, { 
    //   metaReducers,
    //   runtimeChecks: {
    //     strictStateImmutability: true,
    //     strictActionImmutability: true,
    //     strictActionSerializability: true,
    //     strictStateSerializability: true
    //   } 
    // }),
    StoreModule.forRoot({}),
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production }),
    // !environment.production ? StoreDevtoolsModule.instrument() : []
    EffectsModule.forRoot([]),
    // StoreRouterConnectingModule.forRoot({
    //   stateKey: 'router',
    //   routerState: RouterState.Minimal
    // })
    
    
  ],
  providers: [{ provide: LOCALE_ID, useValue: 'tr' }],
  bootstrap: [AppComponent]
})
export class AppModule { }
